import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { AdminShell } from '@/components/AdminShell';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireDoctor?: boolean;
}

export const ProtectedRoute = ({
  children,
  requireAdmin = false,
  requireDoctor = false,
}: ProtectedRouteProps) => {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();
  const { getLocalizedPath } = useLanguage();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={getLocalizedPath('/auth')}
        replace
        state={{ from: location }}
      />
    );
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to={getLocalizedPath('/')} replace />;
  }

  // Placeholder for future doctor role enforcement
  if (requireDoctor) {
    return <>{children}</>;
  }

  return requireAdmin ? <AdminShell>{children}</AdminShell> : <>{children}</>;
};

